import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영>요약] VMS 성능위젯 정보 조회
   * @author Song
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltList(params) {
    return axios.post(`${baseUrl}/virtual/performance/summary/get-${params.objtype}-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-list.do`, params);
  },
  /**
   * [성능/운영>요약] VMS 성능위젯 정보 조회 (후면)
   * @author Song
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltBackList(params) {
    return axios.post(`${baseUrl}/virtual/performance/summary/get-${params.objtype}-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/virtual/performance/summary.js